<template>
    <div class="flex items-center gap-4">
        <div v-if="image" class="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-slate-100 shadow-sm">
            <img :src="image" class="h-full w-full object-cover" alt="profile picture">
        </div>
        <div class="min-w-0">
            <div class="text-sm font-semibold text-slate-900">{{ name }}</div>
            <div class="text-sm text-slate-600">{{ title }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        name: String,
        title: String,
        image: String
    }
}
</script>